<!--<template>-->
    <!--<div class="bottom">-->
        <!--<ul class="bottom-list">-->
            <!--<li class="bottom-li tab1" @click="go('/')" :class="{'on':currentPage=='home'}">-->
                <!--首页-->
            <!--</li>-->
            <!--<li class="bottom-li tab2" @click="go('/serverList')" :class="{'on':currentPage=='server'}">-->
                <!--家政人员-->
            <!--</li>-->
            <!--<li class="bottom-li tab3" @click="go('/clientList')" :class="{'on':currentPage=='clientList'}">-->
                <!--我的客户-->
            <!--</li>-->
            <!--<li class="bottom-li tab4" @click="go('/center')" :class="{'on':currentPage=='center'}">-->
                <!--个人中心-->
                <!--<i class="bottom-tip">2</i>-->
            <!--</li>-->
        <!--</ul>-->
    <!--</div>-->
<!--</template>-->

<script>
    export default {
        name: "footerTab",
//        data: function () {
//            return {
//                currentPage:this.current
//            }
//        },
//        props: ["current"],
//        methods:{
//            go:function (path) {
//                this.$router.push(path);
//            }
//        }
    }
</script>

<!--<style scoped>-->
    <!--.bottom {-->
        <!--position: fixed;-->
        <!--left: 0;-->
        <!--bottom: 0;-->
        <!--width: 100%;-->
        <!--height: 0.9rem;-->
        <!--background-color: #19171b;-->
        <!--box-sizing: border-box;-->
    <!--}-->

    <!--.bottom-list {-->
        <!--height: 100%;-->
        <!--width: 100%;-->
        <!--padding: 0.1rem 0;-->
        <!--box-sizing: border-box;-->
    <!--}-->

    <!--.bottom-li {-->
        <!--float: left;-->
        <!--width: 25%;-->
        <!--height: 100%;-->
        <!--text-align: center;-->
        <!--box-sizing: border-box;-->
        <!--border-right: 1px solid #8e8e8f;-->
        <!--color: #8e8e8f;-->
        <!--line-height: 1.2rem;-->
        <!--position: relative;-->
    <!--}-->

    <!--.bottom-li:last-child {-->
        <!--border-right: 0;-->
    <!--}-->

    <!--.bottom-tip {-->
        <!--width: 0.4rem;-->
        <!--height: 0.4rem;-->
        <!--position: absolute;-->
        <!--left: 50%;-->
        <!--top: -0.05rem;-->
        <!--margin-left: 0.4rem;-->
        <!--background-color: #c30d23;-->
        <!--text-align: center;-->
        <!--color: white;-->
        <!--line-height: 0.4rem;-->
        <!--border-radius: 50%;-->
        <!--font-style: normal;-->
    <!--}-->

    <!--.tab1{-->
        <!--background: url("../assets/images/151_03.png") no-repeat center 0rem;background-size: 0.4rem 0.4rem;-->
    <!--}-->
    <!--.tab2{-->
        <!--background: url("../assets/images/151_05.png") no-repeat center 0rem;background-size: 0.4rem 0.4rem;-->
    <!--}-->
    <!--.tab3{-->
        <!--background: url("../assets/images/151_24.png") no-repeat center 0rem;background-size: 0.4rem 0.4rem;-->
    <!--}-->
    <!--.tab4{-->
        <!--background: url("../assets/images/151_09.png") no-repeat center 0rem;background-size: 0.4rem 0.4rem;-->
    <!--}-->
    <!--.tab5{-->
        <!--background: url("../assets/images/246_03.png") no-repeat center 0rem;background-size: 0.57rem 0.4rem;-->
    <!--}-->
    <!--.tab6{-->
        <!--background: url("../assets/images/151_07.png") no-repeat center 0rem;background-size: 0.4rem 0.4rem;-->
    <!--}-->
    <!--.tab1.on{-->
        <!--background-image: url("../assets/images/151_15.png");-->
    <!--}-->
    <!--.tab2.on{-->
        <!--background-image: url("../assets/images/151_19.png");-->
    <!--}-->
    <!--.tab3.on{-->
        <!--background-image: url("../assets/images/151_25.png");-->
    <!--}-->
    <!--.tab4.on{-->
        <!--background-image: url("../assets/images/151_23.png");-->
    <!--}-->
    <!--.tab5.on{-->
        <!--background-image: url("../assets/images/246_06.png");-->
    <!--}-->
    <!--.tab6.on{-->
        <!--background-image: url("../assets/images/151_21.png");-->
    <!--}-->
    <!--.bottom-li.on{-->
        <!--color: #f0861b;-->
    <!--}-->
    <!--.bottom-list-3 .bottom-li{-->
        <!--width: 33%;-->
    <!--}-->

    <!--.bottom-list-3 .bottom-li {-->
        <!--width: 33%;-->
    <!--}-->

    <!--.bottom-li.on {-->
        <!--color: #f0861b;-->
    <!--}-->
<!--</style>-->



// WEBPACK FOOTER //
// src/ally/components/bottom.vue